import { gsap, Cubic } from "gsap";
export default class ForgotPasswordModal {
  constructor() {
    this.contents = document.querySelector("._forgot_password_modal");
    document.body.appendChild(this.contents);
    this.container = this.contents.querySelector("._container");

    this.open = document.querySelectorAll(".f-forgotPasswordOpen");
    this.close = document.querySelectorAll(".f-forgotPasswordClose");

    this.input = this.contents.getElementsByTagName("input")[0];
    this.submit = this.contents.querySelector("._submit");

    this.isOpen = false;

    this.setup();
  }

  setup() {
    this.close.forEach((elm, index) => {
      elm.addEventListener("click", (event) => {
        if (this.isOpen) {
          this.isOpen = false;

          gsap.to(this.contents, {
            display: "none",
            opacity: 0,
            duration: 0.3,
            ease: Cubic.easeInOut
          });
          gsap.fromTo(
            this.container,
            {
              marginTop: 0
            },
            {
              marginTop: 30,
              duration: 0.3,
              ease: Cubic.easeIn
            }
          );
        }
      });
    });
    this.open.forEach((elm, index) => {
      elm.addEventListener("click", (event) => {
        if (!this.isOpen) {
          this.isOpen = true;

          gsap.to(this.contents, {
            display: "block",
            opacity: 1,
            duration: 0.3,
            ease: Cubic.easeInOut
          });
          gsap.fromTo(
            this.container,
            {
              marginTop: 30
            },
            {
              marginTop: 0,
              duration: 0.6,
              ease: Cubic.easeOut
            }
          );
          setTimeout(
            function () {
              this.contents.focus();
            }.bind(this),
            300
          );
        }
      });
    });
  }
}
